"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
exports.makeCodeCell = immutable_1.Record({
    cell_type: "code",
    execution_count: null,
    metadata: immutable_1.Map({
        collapsed: false,
        outputHidden: false,
        inputHidden: false
    }),
    source: "",
    outputs: immutable_1.List()
});
exports.makeMarkdownCell = immutable_1.Record({
    cell_type: "markdown",
    metadata: immutable_1.Map(),
    source: ""
});
exports.makeRawCell = immutable_1.Record({
    cell_type: "raw",
    metadata: immutable_1.Map(),
    source: ""
});
